import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OAuthModule } from 'angular-oauth2-oidc';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { InterceptService } from './modules/core/intercept.service';
import { LayoutModule } from './modules/layout/layout.module';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button';
import { SharedModule } from './shared/shared.module';
import { CacheInterceptor } from './modules/core/cache.interceptor';
import { ServiceWorkerModule } from '@angular/service-worker';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { environment } from '../environments/environment';
import { CacheMapService } from './modules/core/cache-map.service';
import { Cache } from './modules/core/cache';
import { SplashScreenComponent } from './components/splash-screen/splash-screen.component';
import { AuthService } from './auth.service';
import { NgxEchartsModule } from 'ngx-echarts';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    OAuthModule.forRoot(),
    LayoutModule,
    BrowserAnimationsModule,
    MatSidenavModule,
    MatButtonModule,
    LoadingBarRouterModule,
    SharedModule.forRoot(),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerImmediately',
    }),
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts'),
    }),
    SplashScreenComponent,
  ],
  providers: [
    InterceptService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CacheInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptService,
      multi: true,
    },
    CacheMapService,
    {
      provide: Cache,
      useClass: CacheMapService,
    },
    AuthService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
